import { CrudMode, FormItem, SelectOptions } from '@ohpen/enso-ui';
import type { RenderFormItem } from '@ohpen/enso-ui';
import { DEFAULT_TEXT_MAX_LENGTH_LONG, DEFAULT_TEXT_MAX_LENGTH_SHORT, textLimitProps } from '@pmp/utils';

export const getFormSchema = (
  firmsOptions: SelectOptions,
  principalsOptions: SelectOptions,
  renderSelectedFirms: RenderFormItem<Record<string, unknown>>,
  mode?: CrudMode | null,
): FormItem[] => {
  const disabled = mode === CrudMode.VIEW;

  return [
    {
      title: 'pmp.exclusiveProducts.labels.id',
      dataIndex: 'id',
      formItemProps: {
        required: true,
        hidden: mode === CrudMode.CREATE,
      },
      fieldProps: {
        disabled: true,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.name',
      dataIndex: 'name',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
        ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.description',
      dataIndex: 'description',
      fieldProps: {
        disabled,
        ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_LONG),
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.startDate',
      dataIndex: 'startDate',
      valueType: 'date',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.endDate',
      dataIndex: 'endDate',
      valueType: 'date',
      fieldProps: {
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.network',
      dataIndex: 'principal',
      valueType: 'select',
      tooltip: 'pmp.exclusiveProducts.labels.networkTooltip',
      fieldProps: {
        options: principalsOptions,
        showSearch: true,
        optionFilterProp: 'label',
        allowClear: true,
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.firms',
      dataIndex: 'firms',
      valueType: 'select',
      fieldProps: {
        mode: 'multiple',
        options: firmsOptions,
        showSearch: true,
        optionFilterProp: 'label',
        maxTagCount: 'responsive',
        disabled,
      },
    },
    {
      title: 'pmp.exclusiveProducts.labels.selectedFirms',
      dependencies: ['firms'],
      renderFormItem: renderSelectedFirms,
    },
  ];
};
